<table class="table table-responsive">
  <thead>
    <th *ngFor="let col of columns" [class.hasorder]="col.order"
      [class.active-order]="pageControl.orderField === col.slug" (click)="onClickOrderBy(col.slug, col.order)">
      {{ col.title }}
      <i class="material-icons" *ngIf="pageControl.orderField === col.slug">
        {{ pageControl.order === 'DESC' ? 'arrow_downward' : 'arrow_upward' }}
      </i>
    </th>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td [attr.colspan]="columns.length">
        <div class="loader-bubble loader-bubble-primary d-block"></div>
      </td>
    </tr>
    <ng-container *ngIf="!loading">
      <tr *ngIf="!list.length">
        <td [attr.colspan]="columns.length" class="text-center">
          <div>Nenhum resultado encontrado</div>
        </td>
      </tr>
      <tr class="hover" style="outline: none;" *ngFor="let p of list">
        <td>
          <div>{{ p.patientName }}</div>
        </td>
        <td>
          <div>{{ p.commentary }}</div>
        </td>
        <td>
          <div>
            {{ p.score }}
            <img class="" src="assets/images/star.png" alt="">
          </div>
        </td>
        <td>
          <button class="btn-action" (click)="deleteCommentary(p.id)" mat-icon-button matTooltip="Remover comentário">
            <i class="fal fa-trash"></i>
          </button>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
<mat-paginator [length]="pageControl.count" [pageIndex]="pageControl.page" [pageSizeOptions]="[10, 25, 50, 100]"
  [pageSize]="pageControl.limit" (page)="pageEvent($event)"></mat-paginator>
